import { createSignal, onCleanup, onMount, Show } from "solid-js";
import { AppShell } from "./components/AppShell";
import { installMdtBridge } from "./core/bridge";
import {
  bootstrapSession,
  currentUser,
  readSteamAuthReturn,
  sessionReady,
  setSessionReady,
} from "./core/session";
import { CharacterSelectionView } from "./views/CharacterSelectionView";
import { LoginView } from "./views/LoginView";
import { PublicRecordView } from "./views/PublicRecordView";

export function App() {
  const publicRecordToken = window.location.pathname.match(
    /^\/public\/records\/([^/]+)\/?$/,
  )?.[1];
  const publicReport = window.location.pathname.match(
    /^\/public\/reports\/(\d+)\/(\d+)\/?$/,
  );
  const [steamAuthReturn, setSteamAuthReturn] = createSignal(
    readSteamAuthReturn(window.location),
  );

  onMount(() => {
    if (publicRecordToken || publicReport) return;
    const removeBridge = installMdtBridge();
    onCleanup(removeBridge);

    if (steamAuthReturn()) {
      setSessionReady(true);
    } else {
      void bootstrapSession();
    }
  });

  if (publicRecordToken || publicReport) {
    const endpoint = publicRecordToken
      ? `/public/records/${publicRecordToken}`
      : `/public/reports/${publicReport![1]}/${publicReport![2]}`;
    return <PublicRecordView endpoint={endpoint} />;
  }

  return (
    <Show
      when={sessionReady()}
      fallback={
        <main class="dump-root flex h-screen w-full items-center justify-center px-14" />
      }
    >
      <Show
        when={currentUser()}
        fallback={
          <Show when={steamAuthReturn()} fallback={<LoginView />}>
            {(authReturn) => (
              <CharacterSelectionView
                authReturn={authReturn()}
                onAuthenticated={() => setSteamAuthReturn(null)}
              />
            )}
          </Show>
        }
      >
        <AppShell />
      </Show>
    </Show>
  );
}
